import React from 'react';
import PropTypes from 'prop-types';
// material
import { Typography, Stack } from '@material-ui/core';

LabelFields.propTypes = {
  title: PropTypes.string,
  required: PropTypes.bool
};

export default function LabelFields({ title, required }) {
  return (
    <Stack direction="row" sx={{ mt: required ? 0 : '0.1rem' }}>
      <Typography variant="body2" color="grey.500" fontWeight="600">
        {title}
      </Typography>
      {required && <Typography color="primary">*</Typography>}
    </Stack>
  );
}
